import * as React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import TopBanner from 'modules/core/components/TopBanner'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import ContactModal from 'modules/billing/components/ContactModalPage'
import useCustomerSupportDetails from 'modules/onboarding/hooks/customerSupportDetails/useCustomerSupportDetails'
import qualificationEntries from 'modules/onboarding/store/collections/qualificationEntries'
import QualificationEntry from 'modules/onboarding/store/models/QualificationEntry'

export interface Props {
  notification: string
}

const AnnouncementBanner = ({ notification }: Props) => {
  const { email } = useCurrentSession()
  const { customCustomerContactUrl } = useCustomerSupportDetails()
  const [isModalOpen, setIsModalOpen] = React.useState(false)

  const handleClick = async () => {
    if (customCustomerContactUrl) {
      window.open(customCustomerContactUrl, '_blank')
    } else {
      const { success } = await asyncAction(
        () => {
          return qualificationEntries.create({
            contact_email: email,
            target: QualificationEntry.TargetTeams.sales,
            marketing_form_campaign: QualificationEntry.Campaigns.contactSalesApp,
          })
        },
        {
          errorFlash: true,
          successFlash: false,
        }
      )
      if (success) {
        setIsModalOpen(true)
      }
    }
  }

  return (
    <>
      <div>
        <TopBanner type="default">
          <Box flexDirection="row" flexGrow alignItems="center">
            <div>
              <Icon.Medium icon="alert-circle" />
            </div>
            <Box paddingLeft="s8">
              <Text size="300" color="grey1000">
                {notification}
              </Text>
            </Box>
            <Box gap="s16" flexDirection="row" flexGrow justifyContent="flexEnd">
              <Button type={'secondary'} onClick={handleClick}>
                {i18n.t('common.contact_us')}
              </Button>
            </Box>
          </Box>
        </TopBanner>
      </div>
      {isModalOpen && <ContactModal onClose={() => setIsModalOpen(false)} />}
    </>
  )
}

export default AnnouncementBanner
